import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { reduxKey } from './constants';
import { handleActions } from 'redux-actions';
import { initializeHead } from './actions';
const handler = handleActions({
    [initializeHead.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            headState: action.payload.head
        })
}, {
    headState: {
        title: '',
        link: [],
        meta: [],
        script: [],
        style: []
    }
});
const reducers = {
    [`${reduxKey}`]: handler
};
export default reducers;
